import React from 'react';
import defaultConnect from '../../../../../components/redux/defaultConnect';
import makeRequest from '../../../../../lib/apiService';
import { WafoForm, WafoFormAutocomplete } from '@wafo/forms';
import "./styles.css";

class ModalGeocerca extends React.Component {
    state = {
        list: [],
        geofence: {
            id_geofence: 0
        },
        autocomplete: React.createRef()
    }

    componentDidMount() {
        this.getData();
    }

    getData = async () => {
        const { setLoading, pushError } = this.props;

        try {
            setLoading(true);
            let geocercas = await makeRequest(
                `geofences/?limit=99999`,
                { method: 'GET' },
            );
            this.setState({ list: geocercas.rows }, () => {
                setLoading(false);
            });
        } catch (error) {
            setLoading(false);
            pushError(error.message);
        }
    }

    handleFormSubmit = async (form) => {
        const { setLoading, pushAlerta, pushError, pushSuccess, closeModal, updateTable, id } = this.props;

        if (!form.valid) {
            pushAlerta({
                type: 'warning',
                title: '¡Hay un problema!',
                message: 'Algunos de los campos en la forma tienen problemas.',
                timer: 3000,
            });
            return;
        }

        setLoading(true);
        const body = {
            id_geofence: form.id_geofence.value.id_geofence
        };

        try {
            await makeRequest(
                `vehicles/${id}/geofences`,
                { method: 'PUT' },
                body
            );
            setLoading(false);
            pushSuccess('Se han guardado los cambios.', 3000);
            updateTable();
            closeModal();
        } catch (error) {
            setLoading(false);
            pushError(error.message);
        }
    }

    render() {
        const { list, geofence } = this.state;
        const { closeModal, ref } = this.props;

        return (
            <div className="modal-vehicle">
                <div className="backdrop">
                    <div className="card animate-in">
                        <div className="card-header">
                            <h5 className="modal-title">
                                Asignar geocerca
                            </h5>
                            <button
                                type="button"
                                className="close"
                                data-dismiss="modal"
                                aria-label="Close"
                                onClick={closeModal}
                            >
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div className="card-body detalles">
                            <WafoForm
                                key={geofence.id_geofence}
                                buttonText="Guardar"
                                onSubmit={this.handleFormSubmit}
                                values={geofence}
                            >

                                <WafoFormAutocomplete
                                    ref={ref}
                                    name="id_geofence"
                                    customClass="col-12"
                                    label="Geocerca"
                                    placeholder="Seleccione una geocerca"
                                    items={list}
                                    filterItemsFN={(items, query) => items.filter(item => (
                                        item.name.toLowerCase().indexOf(query.toLowerCase()) !== -1
                                        || item.key.toLowerCase().indexOf(query.toLowerCase()) !== -1
                                    ))}
                                    customItemFN={item => `${item.key} - ${item.name}`}
                                    customInputFN={item => `${item.key} - ${item.name}`}
                                />

                            </WafoForm>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default defaultConnect(ModalGeocerca);